import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import MoreLink from 'commonComponents/MoreLink/MoreLink';
import styles from './StepsSection.module.scss';

const StepsSection = ({ logo, title, complex_title: complexTitle, text, link, list }) => {
  return (
    <BaseSection additionalClass={ styles.StepsSection }>
      <h2 className={ styles.header }>
        <img src={ logo } width="48" />
        { title }
      </h2>
      <div className={ styles.description }>
        { complexTitle && <ComplexTitle list={ complexTitle } /> }
        <p className={ styles.text }>{ text }</p>
        <p><MoreLink { ...link } /></p>
      </div>
      { list && list.map((step, i) => (
        <Step key={ step.title } { ...step }
          index={ i + 1 }
        />
      )) }
    </BaseSection>
  );
};

const ComplexTitle = ({ list }) => {
  return (
    <h4 className={ styles.ComplexTitle }>
      { list.map(item => <span className={ styles.part } key={ item }>{ item } </span>) }
    </h4>
  );
};

const Step = ({ index, title, text, graphics, link }) => {
  return (
    <div className={ styles.Step }>
      <div className={ styles.text }>
        <h5 className={ styles.header }>{ index }. { title }</h5>
        <p>{ text }</p>
        { link && <p><MoreLink { ...link } /></p> }
      </div>
      <figure className={ styles.graphic }>{ graphics }</figure>
    </div>
  );
};
 
export default StepsSection;
